import React, { Component, PropTypes, Redirect } from "react";
import {
  getSignUp,
  Userregistercheck,
  logout,
  userprofile,
  UpdateProfile,
  CheckUser,
  deleteAccount,
} from "../../Model/Users"; //Include Home
import {
  Link,
  useNavigate,
  useHistory,
  browserHistory,
} from "react-router-dom";
import { Metadata } from "../Metadata/Metadata";
import { isMobile } from "react-device-detect";
import {
  Encrypt,
  withRouter,
  VirsionCheck,
  Faq,
  branchIO,
} from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import Profilemenu from "../Profile_menu/Profilemenu";
import BarLoader from "react-spinners/BarLoader";
import Manageprofiledesk from "../../components/Manageprofiledesk/Manageprofiledesk";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      showconfirm: false,
      showDelete: false,
      userData: false,
      childlockbtnConfrim: false,
      userchecked: false,
      showUserStatusPop: false,
      showMessagePop: "",
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
    };
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv,
        goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
        silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
      });
      let data = {
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      }
      userprofile(data).then((userDatares) => {
        if (JSON.parse(userDatares.data.message).success == false) {
          this.props.navigate("/createaccount");
        }

        if (userDatares.data.message == "session_expired") {
          //Redirect To login page.
          this.props.navigate("/createaccount");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            userData: userDatares.user_data,
            userchecked: userDatares.user_data?.is_child,
          });
        }
      });
    });
  }
  /*-----Logout Confirmation popup*/
  logoutconfirm() {
    this.setState({
      showconfirm: true,
    });
  }
  Deleteconfirm() {
    this.setState({
      showDelete: true,
    });
  }
  Childlock() {
    this.setState({
      childlockbtnConfrim: true,
    });
  }
  /*-------Logout-------*/
  Logout() {
    let data = {
      seesionID: localStorage.getItem("session_id"),
      msisdn: localStorage.getItem("msisdn")
    }
    logout(data).then((ResofLogout) => {
      // branchIO("Sign Out", { "user":ResofLogout });
      localStorage.clear();
      window.localStorage.clear()
      this.props.navigate("/createaccount");
    });
  }
  delete() {
    //Call logout Api
    CheckUser().then((res) => {
      let data = {
        user_id: res.user_data?.ID,
        session_id: res.session_id,
        action: 2,
      };

      if (this.state.userData.is_subscribed == true) {
        this.setState({
          showUserStatusPop: true,
          showDelete: false,
          showMessagePop: "You have an active membership with us. Once your membership ends or expires, you will be able to delete your account.",
        });
      } else {
        deleteAccount(data).then((res) => {
          // branchIO("Delete my Account", {"user": data });
          this.setState({
            showUserStatusPop: false,
            showDelete: true,
          });
          this.props.navigate("/createaccount");
        });
      }
    });
  }
  cancel() {
    //Call logout Api
    this.setState({
      showconfirm: false,
      childlockbtnConfrim: false,
      showDelete: false,
      showUserStatusPop: false,
    });
  }

  childlockOn() {
    if (this.state.userchecked == false) {
      var status = "true";
    } else {
      var status = "false";
    }
    var PostData = {
      is_child: status,
    };

    UpdateProfile(PostData).then((resp) => {
      var Respup = JSON.parse(resp.data.message);

      if (Respup.success == true) {
        if (this.state.userchecked == false) {
          this.setState({
            childlockbtnConfrim: false,
            userchecked: true,
          });
        } else {
          this.setState({
            childlockbtnConfrim: false,
            userchecked: false,
          });
        }
      }
    });
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }

    var Logoutconfirm;
    var Deleteconfirm;
    var ChidllockStatus;

    if (this.state.showconfirm == true) {
      var Logoutconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>Are you sure you want to log out?</h6>
            </div>
            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.cancel();
              }}
            >
              Cancel
            </button>
            <p
              className="temp52-modal-close"
              onClick={() => {
                this.Logout();
              }}
            >
              Log Out
            </p>
          </div>
        </div>
      );
    }
    if (this.state.showDelete == true) {
      var Deleteconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>
                Are you sure you want to delete your account? Kindly note this
                action can not be undone.
              </h6>
            </div>

            <p
              type="submit"
              id="sendEnquiryBtn"
              className="temp52-modal-close"
              onClick={() => {
                this.cancel();
              }}
            >
              Cancel
            </p>
            <button
              className="btn-white"
              onClick={() => {
                this.delete();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }
    if (this.state.showUserStatusPop == true) {
      var Deleteconfirm = (
        <div className="logOutpopup" id="logOut">
          <div className="temp52-modal-body">
            <div className="temp52-awesome">
              <h6>{this.state.showMessagePop}</h6>
            </div>
            <button
              className="btn-white"
              onClick={() => {
                this.cancel();
              }}
            >
              OK
            </button>
          </div>
        </div>
      );
    }
    if (this.state.childlockbtnConfrim == true) {
      var ChildlockbtnConfrim = (
        <div className="logOutpopup">
          <div className="temp78-modal-body">
            <div className="temp78-awesome">
              <img src={SVGIcon["child-lock-alert.png"]} />
              {this.state.userchecked ? (
                <h6>
                  You will be able to see our entire vast catalogue again,
                  including ones which are age restricted with Child Lock!
                </h6>
              ) : (
                <h6>
                  Based on our age ratings, some titles may no longer be visible
                  for your account, You may not be able to experience our entire
                  vast catalogue!
                </h6>
              )}

              <h2>
                Are you sure you want to{" "}
                {this.state.userchecked ? "disable" : "enable"} Child Lock?
              </h2>
            </div>
            <p
              className="temp78-modal-close"
              onClick={() => {
                this.cancel();
              }}
            >
              No
            </p>
            <button
              type="submit"
              id="sendEnquiryBtn"
              className="btn-white"
              onClick={() => {
                this.childlockOn();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }
    if (this.state.VirsionCheckDataloaded == false) {
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      if (this.state.userchecked == true) {
        ChidllockStatus = <div className="switch-activ">Active</div>;
      } else {
        ChidllockStatus = <div className="switch-Inactiv">Inactive</div>;
      }
      return (
        <>
          <Metadata page="PROFILE" />
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <main>
                <section className="mb-0 dD-none">
                  <div className="temp46">
                    <div className="temp46-inn">
                      <div className="temp46-area">
                        <Link to="/manage-membership">
                          <div className="img-area">
                            <img
                              src={SVGIcon["manage-membership.svg"]}
                              alt="DocuBay"
                            />
                          </div>
                          My Membership
                        </Link>
                      </div>

                      {/*<div className="temp46-area">
                      <a href="downloads.html">
                        <div className="img-area">
                          <img src={SVGIcon["downloads.svg"]} alt="DocuBay" />
                        </div>
                        Downloads
                      </a>
                    </div>*/}
                      {/*<div className="temp46-area">
                      <div className="img-area">
                        <img src={SVGIcon["gift-card.svg"]} alt="DocuBay" />
                      </div>
                      Gift Card
                    </div>*/}
                      <div className="temp46-area">
                        <div className="img-area">
                          <img src={SVGIcon["child-lock.svg"]} alt="DocuBay" />
                        </div>
                        Child Lock
                        {ChidllockStatus}
                        <label className="switch childLock-modal-toggle">
                          <div
                            className="switch-text"
                            onClick={() => {
                              this.Childlock();
                            }}
                          >
                            {" "}
                            <span>On</span> <span>Off</span>{" "}
                          </div>
                          {/* <input type="checkbox" check> */}
                          <span
                            className={
                              this.state.userchecked ? "slider round" : "slider"
                            }
                            onClick={() => {
                              this.Childlock();
                            }}
                          />
                        </label>
                        {/*<label className="switch">
                          <div className="switch-text">
                            <span>On</span> <span>Off</span>
                          </div>
                          <input
                            type="checkbox"
                            defaultChecked={this.state.userchecked}
                            onClick={() => {
                              this.Childlock();
                            }}
                            value={this.state.userchecked}
                          />
                          <span className="slider round" />
                        </label>*/}
                      </div>
                      {/*<div className="temp46-area">
                      <a href="language.html">
                        <div className="img-area">
                          <img src={SVGIcon["language.svg"]} alt="DocuBay" />
                        </div>
                        Language
                      </a>
                    </div>*/}
                      <div className="temp46-area">
                        <Link to="/about-us">
                          <div className="img-area">
                            <img
                              src={SVGIcon["about.png"]}
                              alt="DocuBay"
                              className="abv"
                            />
                          </div>
                          About
                        </Link>
                      </div>
                      <div className="temp46-area">
                        <Link to="/privacy">
                          <div className="img-area">
                            <img
                              src={SVGIcon["privacy-policy.svg"]}
                              alt="DocuBay"
                            />
                          </div>
                          Privacy Policy
                        </Link>
                      </div>
                      <div className="temp46-area">
                        <Link to="/terms">
                          <div className="img-area">
                            <img
                              src={SVGIcon["terms-of-use.svg"]}
                              alt="DocuBay"
                            />
                          </div>
                          Terms Of Use
                        </Link>
                      </div>
                      <div className="temp46-area">
                        <a
                          className="temp52-modal-toggle"
                          onClick={() => {
                            this.logoutconfirm();
                          }}
                        >
                          <div className="img-area">
                            <img src={SVGIcon["log-out.svg"]} alt="DocuBay" />
                          </div>
                          Log Out
                        </a>
                      </div>
                    </div>
                  </div>
                </section>

                {/* <div className="mainNav pmenu mainNav-1 dD-block"> */}
                <Profilemenu
                  versioncheck={this.state.VirsionCheckData}
                  profile={this.state.userData}
                />
                {/* </div> */}
                <Manageprofiledesk
                  versioncheck={this.state.VirsionCheckData}
                  profile={this.state.userData}
                />
              </main>
              {Logoutconfirm}
              {Deleteconfirm}
              {ChildlockbtnConfrim}
            </>
            {/* {isMobile ? <Mobilemenu active="5" /> : <Profilemenu versioncheck={this.state.VirsionCheckData} profile={this.state.ProfileData} />} */}
            <Mobilemenu active="5" isLive={this.state.isLive} />
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Signup);
